export const CREATE_ORGANIZATION = 'createOrganization';
export const CREATE_ORGANIZATIONS = 'createOrganizations';
export const FETCH_ORGANIZATION_BY_ID = 'fetchOrganizationById';
export const FETCH_ALL_ORGANIZATIONS = 'fetchAllOrganizations';
